const PHONE_NUMBER_REGEX = /^\d{10}$/;

const PHONE_NUMBER_WITH_COUNTRY_CODE_REGEX = /^\+[1-9][0-9]{10}$/;

const EMAIL_ADDRESS_REGEX = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

const PASSWORD_PATTERNS = [
  {test: /.{8,}/, message: "8 characters"},
  {test: /[a-z]/, message: "one lowercase"},
  {test: /[A-Z]/, message: "one uppercase"},
  {test: /[0-9]/, message: "one digit"},
  {test: /[^a-zA-Z0-9\s]/, message: "one special character"},
];

export const validatePhoneNumber = (phoneNumber: string, withCountryCode: boolean): boolean => {
  if (withCountryCode) {
    return PHONE_NUMBER_WITH_COUNTRY_CODE_REGEX.test(phoneNumber);
  }
  return PHONE_NUMBER_REGEX.test(phoneNumber);
}

export const validateEmail = (email: string): boolean => {
  if (email && email.endsWith("@mail.ru")) {
    return false;
  }
  return EMAIL_ADDRESS_REGEX.test(email);
}

export const validatePassword = (password: string): string => {
  const errors = PASSWORD_PATTERNS
    .filter(pattern => !pattern.test.test(password))
    .map(pattern => pattern.message);

  if (errors.length) {
    if (errors.length > 1) {
      errors[errors.length - 1] = 'and ' + errors[errors.length - 1];
    }

    return 'Password must contain at least ' + errors.join(', ') + '.';
  }

  return '';
};

export const parseFormattedPhoneNumber = (formattedPhoneNumber: string): string => {
  return ('' + formattedPhoneNumber).replace(/\D/g, '');
};

export const parseNumericInput = (input: string): string => {
  return input.replace(/\D/g, '');
};

export const formatPhoneNumber = (phoneNumberString: string): string => {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  // match country code too: 1
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[2] + ') ' + match[3] + '-' + match[4];
  }
  return phoneNumberString;
}

export const validateName: (name: string) => boolean = (name) => {
  const alphaNumericSpacesOnly = /^[a-zA-Z0-9- ]*$/;
  return name.length && name.trim().length ? alphaNumericSpacesOnly.test(name) : false;
}

export const validateScacCode = (scacCode: string): boolean => {
  const scacRegex = /^[A-Za-z0-9]{2,4}$/;
  return scacRegex.test(scacCode);
};

export const validatePresentOrFutureDate = (date: string): boolean => {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(date);
  if (!match) return false;

  const [, mm, dd, yyyy] = match;
  const inputDate = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
  if (Number.isNaN(inputDate.getTime())) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  inputDate.setHours(0, 0, 0, 0);
  return inputDate >= today;
}

export const validateFutureDate = (date: string): boolean => {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(date);
  if (!match) return false;

  const [, mm, dd, yyyy] = match;
  const inputDate = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
  if (Number.isNaN(inputDate.getTime())) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  inputDate.setHours(0, 0, 0, 0);
  return inputDate > today;
}
